import { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import SectionObserver from './sectionObserver';

class SubheaderListener extends Component {
  static defaultProps = {
    children: null,
    options: {},
    onView() {},
    reRenderOnScroll: false,
  };

  constructor(props) {
    super(props);
    this.ref = createRef();
  }

  /**
   * Create the event listener on mount
   */
  componentDidMount() {
    this.observer = SectionObserver.get(this.props.options);

    this.container = this.ref.current;

    this.observer.observe(this.container, this.trackEvent);
  }

  shouldComponentUpdate() {
    const { reRenderOnScroll } = this.props;
    return reRenderOnScroll;
  }

  /**
   * Remove the observe listener on unmount
   */
  componentWillUnmount() {
    this.unobserve();
  }

  /**
   * Send the tracking event callback
   * @param  {Boolean} visible - the visibility state of the element
   */
  trackEvent = (visible) => {
    const label = this.props.children[1]
      ? this.props.children[1].props['data-title']
      : this.props.children.props['data-title'];
    visible && this.props.onView(label);
  };

  unobserve() {
    if (typeof this.container !== 'undefined' && this.observer) {
      // Remove the observation listener
      this.observer.unobserve(this.container);
    }
    this.observer = null;
  }

  render() {
    // should only be a single child component
    return (
      <div ref={this.ref}>
        {this.props.children[1] ? this.props.children[1] : this.props.children}
      </div>
    );
  }
}

SubheaderListener.propTypes = {
  children: PropTypes.node,
  options: PropTypes.shape({
    minTimeVisible: PropTypes.number,
    errorMargin: PropTypes.number,
  }),
  onView: PropTypes.func,
  reRenderOnScroll: PropTypes.bool,
};

export default SubheaderListener;
